export const getAgeAtYearEnd = (dateStr) => {
  if (!dateStr) return null;

  const dob = new Date(dateStr);
  if (isNaN(dob.getTime())) return null; // invalid date check

  const currentYear = new Date().getFullYear();
  const endOfYear = new Date(currentYear, 11, 31); // 31/12

  let age = endOfYear.getFullYear() - dob.getFullYear();
  if (
    endOfYear.getMonth() < dob.getMonth() ||
    (endOfYear.getMonth() === dob.getMonth() &&
      endOfYear.getDate() < dob.getDate())
  ) {
    age--;
  }

  return age;
};
